module.exports = __webpack_public_path__ + "img/hotel-blue.e9816daf.png";